import { defineStore } from 'pinia'

type Issue492AbTestResult = {
  isAPattern: boolean
  isBPattern: boolean
}

export const useIssue492AbTestStore = defineStore('ab_test_issue_492', () => {
  const abTestResult = ref<Issue492AbTestResult | null>(null)

  return {
    abTestResult
  }
})
